import z from 'zod';

import { LPSAxisDirSchema } from '@/src/types/lps';

export const Vector3Schema = z.tuple([z.number(), z.number(), z.number()]);

export const CameraConfigSchema = z.object({
  parallelScale: z.number().optional(),
  position: Vector3Schema.optional(),
  focalPoint: Vector3Schema.optional(),
  directionOfProjection: Vector3Schema.optional(),
  viewUp: Vector3Schema.optional(),
});
export type CameraConfig = z.infer<typeof CameraConfigSchema>;

export const SliceConfigSchema = z.object({
  slice: z.number(),
  min: z.number(),
  max: z.number(),
  axisDirection: LPSAxisDirSchema,
});
export type SliceConfig = z.infer<typeof SliceConfigSchema>;

export const WindowLevelConfigSchema = z.object({
  width: z.number(),
  level: z.number(),
  min: z.number(), // data range min
  max: z.number(), // data range max
});
export type WindowLevelConfig = z.infer<typeof WindowLevelConfigSchema>;
